(function () {
  const params = new URLSearchParams(window.location.search);
  const autoAddParam = params.get('auto_add');
  if (!autoAddParam) return;
  const variantMap = {
    'starter-pack': '47742473470115',
    'the-baked-box': '46345144238243',
    'coned-variety-pack': '47744903872675',
    'dope-dough-variety-pack': '44686937981091',
    'infused-variety-pack': '45861254070435',
    'gummies-variety-pack': '46370302034083',
    'stockup-pack': '47876944232611'
  };
  const variantId = variantMap[autoAddParam];
  if (!variantId) {
    console.warn('[Auto Add] No variant ID:', autoAddParam);
    return;
  }
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count-indicator]').forEach(function (el) {
      el.textContent = count;
    });
    console.log('[Auto Add] Cart count updated:', count);
  }
  async function autoAdd(retry = 0) {
    try {
      const cart = await fetch('/cart.js', { cache: 'no-store' }).then(res => res.json());
      if (!cart || !cart.items) {
        throw new Error('Cart not ready');
      }
      const existingLine = cart.items.find(
        item => String(item.variant_id) === String(variantId) && item.quantity > 0
      );
      if (!existingLine) {
        // Not in cart - use update.js to set quantity to exactly 1.
        // update.js does NOT trigger Assortion's upsell popup
        // (unlike add.js which Assortion watches for upsells).
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({
            updates: { [variantId]: 1 }
          })
        });
        console.log('[Auto Add] Product silently added:', autoAddParam);
      } else if (existingLine.quantity !== 1) {
        // Already in cart but quantity drifted - correct to 1
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({
            updates: { [variantId]: 1 }
          })
        });
        console.log('[Auto Add] Quantity corrected to 1:', autoAddParam);
      } else {
        console.log('[Auto Add] Already in cart, skipping:', autoAddParam);
      }
      const freshCart = await fetch('/cart.js', { cache: 'no-store' }).then(res => res.json());
      updateCartCount(freshCart.item_count);
    } catch (e) {
      console.warn('[Auto Add] Retrying auto add...', retry);
      if (retry < 3) {
        setTimeout(() => autoAdd(retry + 1), 500);
      } else {
        console.error('[Auto Add] Failed after retries:', e);
      }
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      autoAdd();
    });
  } else {
    autoAdd();
  }
})();